import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';

interface BaseGlowColorPanelProps {
  glowColor: RGBA;
  onUpdateGlow(glowColor: RGBA, undoable?: boolean): void;
}

export function BaseGlowColorPanel({...props}: BaseGlowColorPanelProps): ReactElement<any> {
  const getGlowColor = (): ColorStorage[] => {
    return getColorObjectArrayFromFillColor([props.glowColor]);
  };

  const onChangeGlowColor = (updatedColor: ColorStorage[]): void => {
    props.onUpdateGlow(updatedColor[0].color, false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    props.onUpdateGlow(updatedColor[0].color, true);
  };

  return (
    <PosterEditingBaseColorPanel
      id="item-glow-color-panel"
      color={getGlowColor()}
      isGradientEnabled={false}
      onChangeColor={onChangeGlowColor}
      onChangeEnded={onChangeColorEnded}
      isAlphaDisabled
    />
  );
}
